import React from "react";
import Modal from "../../../../../../common/Modal";
import Button from "../../../../../../common/Button";
import {
  ButtonSpacer,
  SectionActions,
} from "../../../../../../common/Button/styles";

const MeetingModal = ({
  title,
  onClose,
  isDelete,
  deleteProgram,
  cancelMeeting,
}) => {
  return (
    <Modal title={title} onClose={onClose}>
      <SectionActions>
        {/* <Button
          style={{ cursor: "pointer" }}
          text={"Close"}
          onClick={onClose}
        /> */}
        <ButtonSpacer />
        {isDelete ? (
          <Button
            style={{ cursor: "pointer" }}
            text={"Yes, cancel meeting"}
            onClick={deleteProgram}
          />
        ) : (
          <Button
            style={{ cursor: "pointer" }}
            text={"Yes"}
            onClick={cancelMeeting}
          />
        )}
        <ButtonSpacer />
        <Button style={{ cursor: "pointer" }} text={"No"} onClick={onClose} />
      </SectionActions>
    </Modal>
  );
};

export default MeetingModal;
